"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterComponents = exports.isAdminOrAuthor = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var memoize = require("fast-memoize");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var WizardActions = require("@caddigital/sok-reducers/lib/actions/order/wizard");
var toastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var Types = require("types");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var translate_1 = require("utils/translate");
var mapStateToProps = function (state) { return ({
    isSaving: state.order.wizard.isSaving,
    isFetching: state.order.wizard.isFetching,
    author: state.order.wizard.values.author,
    wizardStep: state.order.wizard.wizardStep,
    checkingFiles: state.order.wizard.checkingFiles,
    proceedWithoutInvalidFiles: state.order.wizard.values.proceedWithoutInvalidFiles,
    distributionLists: state.order.wizard.values.distributionLists,
    orderRecipients: state.order.wizard.values.orderRecipients,
    orderId: state.order.wizard.values.orderId,
    location: state.router.location,
    values: state.order.wizard.values,
    fileHistory: state.order.wizard.fileHistory,
    orderFilesStatus: state.order.wizard.orderFilesStatus,
    recipientsStatus: state.order.recipients.list.status,
    printProvidersStatus: state.order.printProviders.status,
    finishingssStatus: state.order.finishings.status,
    deliveryMethodStatus: state.order.deliveryMethods.status,
    billingInformationStatus: state.order.billingInformations.status
}); };
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    changeStep: function (step, mode, type) { return function () {
        return dispatch(WizardActions.changeStep(step, mode, type));
    }; },
    noRecipientsNotification: function () {
        return dispatch(toastActions.addNewToast((0, translation_1.getLocalization)('order/toast/header'), (0, translation_1.getLocalization)('order/toast/content'), 'NORMAL', [], undefined, 0));
    },
    orderReady: function (props, orderType) {
        return function () {
            if (orderType !== 'AUTOMATIC_SAVE') {
                dispatch(WizardActions.changeStep(4, props.mode, props.type));
            }
            var type = orderType === 'ORDER'
                ? { type: 'ORDER' }
                : {
                    type: 'AUTOMATIC_ORDER',
                    mode: orderType === 'AUTOMATIC_ORDER' ? 'ORDER' : 'SAVE'
                };
            dispatch(WizardActions.createNewOrderRequest(type, props.currentFolder.id));
        };
    }
}); };
//#region Types
var mapDispatchToPropsExtractable = Types.extractReturnType(mapDispatchToProps);
//#endregion
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (this.props.values.status === 'ERROR' &&
            prevProps.values.status === 'INITIAL') {
            this.props.noRecipientsNotification();
        }
    }
}), recompose_1.pure);
var dataFetched = function (props) {
    return (props.recipientsStatus !== 'FETCHED' ||
        props.printProvidersStatus !== 'FETCHED' ||
        props.finishingssStatus !== 'FETCHED' ||
        props.deliveryMethodStatus !== 'FETCHED' ||
        props.billingInformationStatus !== 'FETCHED');
};
var isAdminOrAuthor = function (props) {
    var perm = props.currentProject.perm
        ? props.currentProject.perm & ~acl.FEATURE_MASK
        : 0x00;
    return (!!(perm & acl.PROJECT_ADMIN_GRANT) ||
        props.user.fold(false, function (u) {
            return u.level === 'SuperAdminUserGroup' || u.level === 'SalesmanUserGroup';
        }) ||
        props.user.fold(false, function (u) {
            return props.author ? u.uuid === props.author.uuid : false;
        }));
};
exports.isAdminOrAuthor = isAdminOrAuthor;
var validateOrderRecipients = memoize(function (orderRecipients) {
    return Object.keys(orderRecipients).length > 0;
});
var validateDistributionRecipients = memoize(function (distributionLists) {
    for (var _i = 0, distributionLists_1 = distributionLists; _i < distributionLists_1.length; _i++) {
        var list = distributionLists_1[_i];
        for (var _a = 0, _b = list.recipients; _a < _b.length; _a++) {
            var recipient = _b[_a];
            if (!recipient.excluded) {
                return true;
            }
        }
    }
    return false;
});
var validateFiles = memoize(function (files, deleted, hardDeleted) {
    for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
        var file = files_1[_i];
        var isDeleted = deleted[file.uuid] || hardDeleted[file.uuid] || false;
        if (file.type === 'FOLDER' || isDeleted) {
            continue;
        }
        if (!file.excluded) {
            return true;
        }
    }
    return false;
});
var orderButtons = function (props) {
    return props.mode === 'CREATE' || props.mode === 'EDIT' ? (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.Button, { color: 'blue', icon: React.createElement(Icon_1.Icon, { className: "fa-chevron-left" }), text: (0, translation_1.getLocalization)('userfront/orderWizard/previousButton'), disabled: props.checkingFiles.status === 'CHECKING' ||
                props.wizardStep < 1 ||
                props.wizardStep > 3 ||
                (props.wizardStep === 2 &&
                    props.checkingFiles.status === 'INVALID' &&
                    !props.proceedWithoutInvalidFiles), onClick: props.changeStep(props.wizardStep - 1 > -1 ? props.wizardStep - 1 : 0, props.mode, props.type) }),
        React.createElement(sok_ui_1.Button, { color: 'blue', iconRight: React.createElement(Icon_1.Icon, { className: "fa-chevron-right" }), text: (0, translation_1.getLocalization)('userfront/orderWizard/nextButton'), disabled: props.checkingFiles.status === 'FAILED' ||
                props.wizardStep >= 3 ||
                (props.wizardStep === 2 &&
                    !validateFiles(props.checkingFiles.files, props.fileHistory.currentFrame.deleted, props.fileHistory.currentFrame.hardDeleted)), onClick: props.changeStep(props.wizardStep + 1 < 4 ? props.wizardStep + 1 : 3, props.mode, props.type) }),
        React.createElement(sok_ui_1.Button, { color: 'green', icon: React.createElement(Icon_1.Icon, { className: "fa-check" }), text: (0, translation_1.getLocalization)('userfront/orderWizard/confirmButton'), disabled: dataFetched(props) ||
                props.wizardStep < 3 ||
                props.isSaving === 'SAVED' ||
                (props.wizardStep === 2 &&
                    props.checkingFiles.status === 'INVALID' &&
                    !props.proceedWithoutInvalidFiles) ||
                !validateFiles(props.checkingFiles.files, props.fileHistory.currentFrame.deleted, props.fileHistory.currentFrame.hardDeleted), onClick: props.orderReady(props, 'ORDER') }))) : (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.Button, { color: 'blue', text: (0, translation_1.getLocalization)('userfront/orderWizard/order'), onClick: props.orderReady(props, 'ORDER'), disabled: props.mode === 'VIEW' }),
        React.createElement(sok_ui_1.Button, { url: "/".concat((0, translate_1.getLanguage)(), "/projects/").concat(props.currentProject.id, "/").concat(props.type === 'SINGLE' ? 'orders' : 'automatic-orders', "/edit/").concat(props.orderId), color: 'green', disabled: props.orderId === undefined, text: (0, translation_1.getLocalization)('userfront/orderWizard/editAndOrder') })));
};
var automaticOrderButtons = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(sok_ui_1.Button, { color: 'blue', icon: React.createElement(Icon_1.Icon, { className: "fa-chevron-left" }), text: (0, translation_1.getLocalization)('userfront/orderWizard/previousButton'), disabled: props.wizardStep === 0 || props.checkingFiles.status === 'CHECKING', onClick: props.changeStep(props.wizardStep - 1 > -1 ? props.wizardStep - 1 : 0, props.mode, props.type) }),
    React.createElement(sok_ui_1.Button, { color: 'blue', iconRight: React.createElement(Icon_1.Icon, { className: "fa-chevron-right" }), text: (0, translation_1.getLocalization)('userfront/orderWizard/nextButton'), disabled: props.wizardStep >= 3 || props.checkingFiles.status === 'CHECKING', onClick: props.changeStep(props.wizardStep + 1 < 4 ? props.wizardStep + 1 : 3, props.mode, props.type) }),
    React.createElement(sok_ui_1.Button, { color: 'blue', iconRight: React.createElement(Icon_1.Icon, { className: "fa-save" }), text: (0, translation_1.getLocalization)('userfront/orderWizard/saveButton'), onClick: props.orderReady(props, 'AUTOMATIC_SAVE'), disabled: (props.mode === 'EDIT' && props.orderFilesStatus !== 'FETCHED') ||
            dataFetched(props) ||
            props.isSaving === 'SAVING' ||
            props.checkingFiles.status === 'CHECKING' ||
            (props.wizardStep === 4 && props.isSaving !== 'FAILED') ||
            (props.checkingFiles.status === 'INVALID' &&
                !props.proceedWithoutInvalidFiles) }),
    React.createElement(sok_ui_1.Button, { color: 'green', text: (0, translation_1.getLocalization)('userfront/orderWizard/order'), onClick: props.orderReady(props, 'AUTOMATIC_ORDER'), disabled: dataFetched(props) ||
            props.wizardStep < 2 ||
            props.isSaving === 'SAVING' ||
            (props.wizardStep === 4 && props.isSaving !== 'FAILED') ||
            !validateFiles(props.checkingFiles.files, props.fileHistory.currentFrame.deleted, props.fileHistory.currentFrame.hardDeleted) ||
            (!validateOrderRecipients(props.orderRecipients) &&
                !validateDistributionRecipients(props.distributionLists)) ||
            (props.wizardStep === 2 &&
                props.checkingFiles.status === 'INVALID' &&
                !props.proceedWithoutInvalidFiles) }))); };
exports.FooterComponents = enhance(function (props) { return (React.createElement(React.Fragment, null,
    props.isFetching !== 'FETCHING' &&
        (props.type === 'SINGLE' ? (props.isSaving === 'SAVING' ? (React.createElement(React.Fragment, null)) : (orderButtons(props))) : (automaticOrderButtons(props))),
    React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('userfront/orderWizard/close'), onClick: function () {
            if (props.location.state && props.location.state.from) {
                props.history.push(props.location.state.from);
            }
            else {
                props.history.push("/".concat((0, translate_1.getLanguage)(), "/projects/").concat(props.currentProject.id, "/").concat(props.type === 'SINGLE' ? 'orders' : 'automatic-orders'));
            }
        } }))); });
